import React from 'react';
import { Space, Switch, Typography } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@context/ThemeContext';
import { useMedia } from '@hooks/useMedia';
import '../../Header.scss';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';

const { Text } = Typography;

const ThemeToggle = ({ compact = false }) => {
  const { t } = useTranslation();
  const { isMobileOrTable } = useMedia();
  const { isDarkMode, toggleTheme } = useTheme();
  const label = t(isDarkMode ? 'action.useLightTheme' : 'action.useDarkTheme');

  const handleToggleTheme = () => {
    toggleTheme();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleTheme();
    }
  };

  return (
    <>
      {isMobileOrTable && !compact ? (
        <Space className='first-space-item-full theme-toggle-wrapper'>
          <Space size={10}>
            {isDarkMode ? <SunOutlined className='theme-icon' /> : <MoonOutlined className='theme-icon' />}
            <Text>{label}</Text>
          </Space>
          <Switch aria-label={label} checked={isDarkMode} size='small' onClick={handleToggleTheme} />
        </Space>
      ) : (
        <div
          onClick={toggleTheme}
          onKeyDown={handleKeyDown}
          className='theme-toggle'
          role='button'
          tabIndex={0}
          aria-label={label}
        >
          {isDarkMode ? <SunOutlined /> : <MoonOutlined />}
        </div>
      )}
    </>
  );
};

ThemeToggle.propTypes = {
  compact: PropTypes.bool,
};

export default ThemeToggle;
